import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { IApiResponse } from '@scl/core/shared/models/api-response';

export function buildApiUrl(path: string): string {
  return environment.apiUrlBase ? `${environment.apiUrlBase}${path}` : path;
}

export function getApiResponseMessage<T>(response: IApiResponse<T>, fallback: string): string {
  return response.error?.detail ?? response.message ?? fallback;
}

export function getApiErrorMessage(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    const response = typeof error.error === 'object' && error.error !== null
      ? error.error as Partial<IApiResponse<unknown>>
      : null;
    const detail = response?.error?.detail?.trim() || response?.message?.trim();

    if (detail) {
      return detail;
    }

    if (typeof error.error === 'string' && error.error.trim().length > 0) {
      return error.error.trim();
    }

    if (error.message.trim().length > 0) {
      return error.message.trim();
    }

    return `The authentication service returned HTTP ${error.status}.`;
  }

  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message.trim();
  }

  return 'An unexpected error occurred while calling the authentication service.';
}